import type { ReactNode } from 'react'

import { clsx } from 'clsx'

interface LoadingOverlayProps {
  isLoading: boolean
  pulse?: boolean
  className?: string
  children: ReactNode
  opaque?: boolean
}
export const LoadingOverlay = ({
  isLoading,
  pulse = true,
  className,
  children,
  opaque = true,
}: LoadingOverlayProps) => {
  return (
    <div
      className={clsx(
        isLoading && 'relative',
        isLoading && opaque && 'opacity-30',
        isLoading && pulse && 'animate-pulse',
        className,
      )}
    >
      <div
        className={clsx(
          !isLoading && 'hidden',
          'absolute inset-0 cursor-default z-50',
        )}
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()
        }}
      ></div>
      {children}
    </div>
  )
}
